<template>
  <ais-toggle-refinement :attribute="attribute" :label="label">
    <template #default="{ value: item, refine }">
      <div class="form-check">
        <!-- TODO: this is a bit weird, calling a function in a template without
                   that it prints anything -->
        {{ notifyCount(item.isRefined ? 1 : 0) }}

        <input
          :id="`${attribute}-${kebabCase(item.value)}-checkbox`"
          type="checkbox"
          class="form-check-input"
          :checked="item.isRefined"
          :value="item.value"
          @change="() => onRefine(item, refine)"
        />
        <label
          class="filter-label form-check-label"
          :for="`${attribute}-${kebabCase(item.value)}-checkbox`"
        >
          <span>
            {{ label }}
            <span class="count-label">
              {{ item.count ? item.count.toLocaleString() : 0 }}
            </span>
          </span>
        </label>
      </div>
    </template>
  </ais-toggle-refinement>
</template>

<script>
import kebabCase from 'lodash/kebabCase';
import { AisToggleRefinement } from 'vue-instantsearch';

export default {
  components: {
    AisToggleRefinement,
  },
  props: {
    attribute: String,
    label: String,
    notifyCount: Function,
  },
  methods: {
    onRefine(item, refine) {
      this.$nextTick(() => {
        refine(item);
        this.$emit('filter-update', !item.isRefined);
        if (this.notifyCount) {
          this.notifyCount(item.isRefined ? 0 : 1);
        }
      });
    },
    kebabCase: value => kebabCase(value),
  },
};
</script>
